import { clearAxiosHeaders } from "@/config/axios";
import { userStore } from "@/store/user-store";
import { useMsal } from "@azure/msal-react";
import { useCallback } from "react";

export function useLogout(): () => Promise<void> {
  const clearUser = userStore((state) => state.clearUser);
  const { instance } = useMsal();

  return useCallback(async () => {
    clearUser();
    clearAxiosHeaders();
    await instance.logoutRedirect();
  }, [clearUser, instance]);
}
